export enum MediaTypeEnum {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO'
}
